import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { chooseNewMantelpiece, chooseNewScrapbook, } from 'actions/myself';
import { fetchProfile } from 'actions/profile';
import getQualityPickerQualities from 'selectors/profile/getQualityPickerQualitiesByNature';

import ProfileContext from 'components/Profile/ProfileContext';
import QualityPicker from 'components/QualityPicker';
import DisplayItemComponent from './DisplayItemComponent';
import { IAppState } from 'types/app';
import { IQuality } from 'types/qualities';

const labelToQualityPickerHeader = (label: 'Mantelpiece' | 'Scrapbook') => ({
  Mantelpiece: 'Mantelpiece item',
  Scrapbook: 'Scrapbook status',
})[label];

interface State {
  isQualityPickerOpen: boolean,
}

export class DisplayItemContainer extends Component<OwnProps & StateProps, State> {
  static displayName = 'DisplayItemContainer';

  state = {
    isQualityPickerOpen: false,
  };

  handleChoose = async (quality: IQuality) => {
    const {
      dispatch,
      data: { nature },
      profileCharacter: { name: characterName },
    } = this.props;
    const action = nature === 'Thing' ? chooseNewMantelpiece : chooseNewScrapbook;
    await dispatch(action(quality));
    dispatch(fetchProfile(characterName));
  };

  handleClick = () => {
    this.setState({ isQualityPickerOpen: true });
  };

  handleRequestClose = () => {
    this.setState({ isQualityPickerOpen: false });
  };

  render = () => {
    const {
      label,
      data,
      qualityPickerQualities,
    } = this.props;

    const {
      isQualityPickerOpen,
    } = this.state;

    return (
      <ProfileContext.Consumer>
        {({ editable }: { editable: boolean }) => (
          <Fragment>
            <DisplayItemComponent
              data={data}
              editable={editable}
              label={label}
              onClick={editable ? this.handleClick : null}
            />
            {editable && (
              <QualityPicker
                activateButtonLabel="Flaunt"
                header={`Choose your new ${labelToQualityPickerHeader(label)}`}
                isOpen={isQualityPickerOpen}
                onChoose={this.handleChoose}
                onRequestClose={this.handleRequestClose}
                qualities={qualityPickerQualities}
              />
            )}
          </Fragment>
        )}
      </ProfileContext.Consumer>
    );
  }
}

interface OwnProps {
  data: IQuality,
  label: 'Mantelpiece' | 'Scrapbook',
}

const mapStateToProps = (state: IAppState, props: OwnProps) => ({
  profileCharacter: state.profile.profileCharacter,
  qualityPickerQualities: getQualityPickerQualities(state, props),
});

type StateProps = { dispatch: Function } & ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps)(DisplayItemContainer);